export default __webpack_public_path__ + "static/media/cytocaare-banner-10.6ce0a1ca.jpg";